import { LocaleProvider } from "ant-design-vue";
const { ...other } = LocaleProvider;
const YwLocaleProvider = {
	...other,
	name: "YwLocaleProvider",
};

YwLocaleProvider.install = function (Vue) {
	Vue.component(YwLocaleProvider.name, LocaleProvider);
};

export default YwLocaleProvider;
